import {
  ENewbuildingLayoutOffersActionTypes,
  TNewbuildingLayoutOffersSetFavoritePayload,
  TSetFavoriteNewbuildingLayoutOffers,
} from '../newbuildingLayoutOffers/types';
import { actionGenerator } from 'shared/utils/redux';

export const newbuildingLayoutsFavorite: (
  payload: TNewbuildingLayoutOffersSetFavoritePayload,
) => TSetFavoriteNewbuildingLayoutOffers = actionGenerator<
  ENewbuildingLayoutOffersActionTypes.SetFavorite,
  TNewbuildingLayoutOffersSetFavoritePayload
>(ENewbuildingLayoutOffersActionTypes.SetFavorite);
